import React, {
    createContext,
    useEffect,
    useState,
  } from "react";
 
  
  // Create a new context
  const UberBannerContext = createContext();

  
  // Create a component that will provide the context
  function UberBannerProvider({ children }) {
   
    const [showBanner, setShowBannerAnimate] = useState(true);

    // Temporary disabling this logic
    // useEffect(() => {
    //   const isShowBannerKeyPresent = localStorage.getItem("showUberBanner");
    //   setShowBannerAnimate(isShowBannerKeyPresent !== 'false');
    // }, [showBanner]);
  
    // Use the Provider component to wrap the children and provide context values
    return (
      <UberBannerContext.Provider
        value={{
            showBanner,
            setShowBannerAnimate
        }}
      >
        {children}
      </UberBannerContext.Provider>
    );
  }
  
  export { UberBannerContext, UberBannerProvider };
  